/* eslint-disable no-empty */
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  const {nachweise, praxisaufgaben, wissensportal, ausbildungsplan} = result
  return {
    ...state,
    isLoading: false,
    nachweise,
    praxisaufgaben,
    wissensportal,
    ausbildungsplan,
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action() {
  let nachweise
  try {
    nachweise = await Api.getAusbildungsnachweiseAzubiDashboard()
  } catch {}

  let praxisaufgaben
  try {
    praxisaufgaben = await Api.readPraxisaufgabenForAzubiDashboard()
  } catch {}

  let wissensportal
  try {
    wissensportal = await Api.getWissensportalDegreeOfCompletion()
  } catch {}

  let ausbildungsplan
  try {
    ausbildungsplan = await Api.readAusbildungsplanForAzubiDashboard()
  } catch {}

  const result = {
    nachweise,
    praxisaufgaben,
    wissensportal,
    ausbildungsplan,
  }
  return result
}
